import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { ProvinceModel, DistrictModel, SubDistrictModel, AddressListItemModel } from '../model/AddressModel.js';

/**
 * @method apiGetProvinceFilterByZipcode
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    /**
     * @param {number} strZipcode
     */
    apiGetProvinceFilterByZipcode: function(strZipcode) {
        var params = {
            zip_code: strZipcode,
        };

        var strUrl = this.config().bzbsUrl + "/main/postcode";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, null, params).then((response) => {
                var data = response.data;
                var listProvince = [];
                var listDistrict = [];
                var listSubDistrict = [];

                for (var i = 0; i < data.length; i++) {
                    // Add List Province
                    var prov = new ProvinceModel(data[i]);
                    var isDuplicateProvince = false;
                    for (var j = 0; j < listProvince.length; j++) {
                        if (listProvince[j].provinceNameEN == prov.provinceNameEN) {
                            isDuplicateProvince = true;
                            break;
                        }
                    }

                    if (!isDuplicateProvince) {
                        listProvince.push(prov);
                    }

                    // Add List District
                    var dis = new DistrictModel(data[i]);
                    var isDuplicateDistrict = false;
                    for (var k = 0; k < listDistrict.length; k++) {
                        if (listDistrict[k].districtNameEN == dis.districtNameEN) {
                            isDuplicateDistrict = true;
                            break;
                        }
                    }

                    if (!isDuplicateDistrict) {
                        listDistrict.push(dis);
                    }

                    // Add List SubDistrict
                    var subDis = new SubDistrictModel(data[i]);
                    var isDuplicateSubDistrict = false;
                    for (var l = 0; l < listSubDistrict.length; l++) {
                        if (listSubDistrict[l].subdistrictNameEN == subDis.subdistrictNameEN) {
                            isDuplicateSubDistrict = true;
                            break;
                        }
                    }

                    if (!isDuplicateSubDistrict) {
                        listSubDistrict.push(subDis);
                    }
                }

                if (listProvince.length > 0) {
                    var allAddress = {
                        listProvince: listProvince,
                        listDistrict: listDistrict,
                        listSubDistrict: listSubDistrict,
                    };
                    resolve(allAddress);
                } else {
                    reject('notfound');
                }
            }).catch((error) => {
                reject(error);
            });
        });
    },

    //#region address list
    apiGetAddressList: function (bzbsToken) {
        var strUrl = `${this.config().bzbsUrl}/profile/me/addresses`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, bzbsToken, null).then((response) => {
                var addressList = [];
                var data = response.data;
                if (data instanceof Array) {
                    data.forEach(address => {
                        addressList.push(new AddressListItemModel(address));
                    });
                }

                resolve(addressList);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    apiAddAddress(bzbsToken, params) {
        var strUrl = `${this.config().bzbsUrl}/profile/me/address`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(strUrl, bzbsToken, params).then((response) => {
                var data = response.data;
                resolve(new AddressListItemModel(data));
            }).catch((error) => {
                reject(error);
            });
        });
    },
    apiUpdateAddress(bzbsToken, params) {
        var strUrl = `${this.config().bzbsUrl}/profile/me/address`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(strUrl, bzbsToken, params).then((response) => {
                var data = response.data;
                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    apiDeleteAddres(bzbsToken, addressKey) {
        var params = {
            key: addressKey
        };

        var strUrl = `${this.config().bzbsUrl}/profile/me/address`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsDelete(strUrl, bzbsToken, params).then((response) => {
                var data = response.data;
                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    //#endregion address list

    //#region update shipping address after redeem
    apiUpdateAddressAfterRedeem(bzbsToken, redeemKey, redeemAddressConfig) {
        var params = {};

        if (!redeemKey) {
            return null;
        }

        if(redeemAddressConfig.addressKey){
            params.address_key = redeemAddressConfig.addressKey;
        }

        if(redeemAddressConfig.taxKey){
            params.tax_key = redeemAddressConfig.taxKey;
        }

        if(redeemAddressConfig.withholdingtaxKey){
            params.withholdingtax_key  = redeemAddressConfig.withholdingtaxKey;
        }

        var strUrl = Vue.bzbsConfig.bzbsUrl + "/redeem/" + redeemKey + "/address";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(strUrl, bzbsToken, params).then((response) => {
                var data = response.data;
                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    //#endregion update shipping address after redeem
}
